// tan-stack
import { useQuery } from "@tanstack/react-query";
import { getNewsByRoleLatest, IContent, ITuanSanResponse } from "../api/news";


export interface ITuanSanDTO {
  id: string;
  articleLink: string;
  role: string;
  videoLink: string;
  contentList: IContent[];
  createdAt: string;
  updatedAt: string;
  imageQRCode: string;
  newNumber: string;
}

const parseTuanSanDTO = (tuansan: ITuanSanResponse | undefined): ITuanSanDTO => {
    return {
        id: tuansan?.id || "",
        articleLink: tuansan?.articleLink || "",
        role: tuansan?.role || "",
        videoLink: tuansan?.videoLink || "",
        contentList: tuansan?.contentList || [],
        createdAt: tuansan?.createdAt || "",
        updatedAt: tuansan?.updatedAt || "",
        imageQRCode: tuansan?.imageQRCode || "",
        newNumber: tuansan?.newNumber || "",
    } 
}   
  
export const useNews = (role: string, isNewsLatest: boolean, key: string) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['news', role, isNewsLatest, key],
    queryFn: async () =>
      await getNewsByRoleLatest(role, isNewsLatest, key),
    enabled: Boolean(role),
  });

  return {
    data: data ? parseTuanSanDTO(data) : undefined,
    isLoading,
    error,
  };
};
